import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';

export class DeliverooApiService extends ApiService<any> {
  constructor() {
    super('deliveroo', 'v1');
  }

  public getSyncJobs(params: any): AxiosPromise<any> {
    return axios.get(`${this.getBaseUrl()}/jobs`, {
      params,
    });
  }

  public syncFoodcard(payload: { venue: string }): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/menus/venues/${payload.venue}`);
  }

  public updateOpeningHours(payload: { venue: string }): AxiosPromise<void> {
    return axios.patch(`${this.getBaseUrl()}/venues/${payload.venue}/opening-hours`);
  }

  public getStatus(payload: { venue: string }) {
    return axios.get(`${this.getBaseUrl()}/venues/${payload.venue}/status`);
  }
}
